import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Typography, Box,
    Grid, FormControl, InputLabel, Select, MenuItem,
    Checkbox, FormControlLabel, Switch,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import api from './api';

// Listas de ejemplo, cámbialas si tienes datos dinámicos

const lista_periodicidad = ['Diaria', 'Semanal', 'Mensual', 'Semestral'];
const roles = ['admin', 'operator', 'coordinador', 'supervisor', 'tecnico'];

// Pregunta vacía con nuevas propiedades para opciones de lista
const createEmptyQuestion = () => ({
    pregunta: '',
    orden: '',
    tipo_respuesta: '',
    tipo_respuesta_label: '',
    opciones: [],
    opcion_temp: '',
    aplica_semaforo: false,
    maximo: '',
    minimo: '',
    respuesta_correcta_lista: ''
});

function TipoRutinaCreate({ open, onClose, onSave }) {
    const [fabricantes, setFabricantes] = useState([]);
    const [tiposRespuesta, setTiposRespuesta] = useState([]);


    const [formData, setFormData] = useState({
        nombre: '',
        fabricante: '',
        periodicidad: '',
        questions: [createEmptyQuestion()],
        status: false,
        ejecutor: '',
    });

    useEffect(() => {
        const fetchFabricantes = async () => {
            try {
                const response = await api.get('/fabricante/?skip=0&limit=1000');
                const activos = response.data.filter(f => f.is_active);
                setFabricantes(activos);
            } catch (error) {
                console.error('Error cargando fabricantes:', error);
            }
        };

        fetchFabricantes();
    }, []);

    useEffect(() => {
        const fetchTiposRespuesta = async () => {
            try {
                const response = await api.get('/tipos_respuestas/?skip=0&limit=1000');
                setTiposRespuesta(response.data);
            } catch (error) {
                console.error('Error cargando tipos de respuesta:', error);
            }
        };

        fetchTiposRespuesta();
    }, []);



    // Handlers generales
    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleQuestionChange = (index, e) => {
        const { name, value, checked, type } = e.target;
        setFormData((prev) => {
            const newQuestions = [...prev.questions];
            newQuestions[index] = {
                ...newQuestions[index],
                [name]: type === 'checkbox' ? checked : value
            };
            if (name === 'tipo_respuesta') {
                //const label = tiposRespuesta.find(tr => tr.id === value)?.tipo || '';
                const selectedTipo = tiposRespuesta.find(tr => tr.id === value);
                newQuestions[index].tipo_respuesta_label = selectedTipo?.tipo || '';
                //newQuestions[index].tipo_respuesta_label = label;
                // Limpiar opciones si el tipo ya no es 'Lista'
                // Si el semáforo está activado y el nuevo tipo no es compatible, desactiva el semáforo.
                if (newQuestions[index].aplica_semaforo && selectedTipo?.tipo !== 'lista' && selectedTipo?.tipo !== 'numero') {
                    newQuestions[index].aplica_semaforo = false;
                    newQuestions[index].maximo = '';
                    newQuestions[index].minimo = '';
                    newQuestions[index].respuesta_correcta_lista = '';
                }
            }
            // Si el checkbox de semáforo se desactiva, limpiar los valores de maximo y minimo
            if (name === 'aplica_semaforo' && !checked) {
                const currentTipoLabel = tiposRespuesta.find(tr => tr.id === newQuestions[index].tipo_respuesta)?.tipo;
                if (!checked) { // Si se desactiva
                    newQuestions[index].maximo = '';
                    newQuestions[index].minimo = '';
                    newQuestions[index].respuesta_correcta_lista = ''; // Siempre limpia los campos al desactivar
                    // También, si se desactiva el semáforo y el tipo de respuesta era 'Lista' o 'Número',
                    // reiniciar a un valor vacío o una opción genérica si aplica.
                    const currentTipoLabel = tiposRespuesta.find(tr => tr.id === newQuestions[index].tipo_respuesta)?.tipo;
                    // Si el tipo actual era 'Lista' o 'Número', reinicia el tipo para que el usuario elija libremente.
                    if (currentTipoLabel === 'lista' || currentTipoLabel === 'numero') {
                        newQuestions[index].tipo_respuesta = '';
                        newQuestions[index].tipo_respuesta_label = '';
                    }
                } else { // Si se activa
                    // Si no hay un tipo compatible seleccionado, intenta preseleccionar 'Número' o 'Lista'.
                    if (currentTipoLabel !== 'numero' && currentTipoLabel !== 'lista') {
                        const numeroTipo = tiposRespuesta.find(tr => tr.tipo === 'numero');
                        const listaTipo = tiposRespuesta.find(tr => tr.tipo === 'lista');
                        if (numeroTipo) {
                            newQuestions[index].tipo_respuesta = numeroTipo.id;
                            newQuestions[index].tipo_respuesta_label = numeroTipo.tipo;
                        } else if (listaTipo) { // Fallback si no hay 'Número'
                            newQuestions[index].tipo_respuesta = listaTipo.id;
                            newQuestions[index].tipo_respuesta_label = listaTipo.tipo;
                        }
                    }
                    // Si ya se activó el semáforo, pero se cambia el tipo de respuesta (dentro del mismo estado)
                    // limpia los campos del otro tipo para evitar conflictos.
                    if (newQuestions[index].tipo_respuesta_label === 'numero') {
                        newQuestions[index].respuesta_correcta_lista = '';
                    } else if (newQuestions[index].tipo_respuesta_label === 'lista') {
                        newQuestions[index].maximo = '';
                        newQuestions[index].minimo = '';
                    }
                }
            }
            // Lógica para limpiar campos si el tipo de respuesta cambia *dentro* del modo semáforo
            else if (newQuestions[index].aplica_semaforo && (name === 'tipo_respuesta' || name === 'aplica_semaforo')) {
                if (newQuestions[index].tipo_respuesta_label === 'numero') {
                    newQuestions[index].respuesta_correcta_lista = '';
                } else if (newQuestions[index].tipo_respuesta_label === 'lista') {
                    newQuestions[index].maximo = '';
                    newQuestions[index].minimo = '';
                }
            }

            return { ...prev, questions: newQuestions };
        });
    };

    // Handler para input de opción temporal
    const handleOpcionTempChange = (index, value) => {
        setFormData((prev) => {
            const newQuestions = [...prev.questions];
            newQuestions[index].opcion_temp = value;
            return { ...prev, questions: newQuestions };
        });
    };

    // Agregar opción
    const handleAddOpcion = (index) => {
        setFormData((prev) => {
            const newQuestions = [...prev.questions];
            const opcion = newQuestions[index].opcion_temp.trim();
            if (opcion && !newQuestions[index].opciones.includes(opcion)) {
                newQuestions[index].opciones.push(opcion);
                newQuestions[index].opcion_temp = '';
            }
            return { ...prev, questions: newQuestions };
        });
    };

    // Eliminar opción
    const handleDeleteOpcion = (qIdx, opIdx) => {
        setFormData((prev) => {
            const newQuestions = [...prev.questions];
            const deletedOption = newQuestions[qIdx].opciones[opIdx]; // Guarda la opción que se va a eliminar
            newQuestions[qIdx].opciones.splice(opIdx, 1);

            // Si la opción eliminada era la respuesta correcta, limpiar respuesta_correcta_lista
            if (newQuestions[qIdx].respuesta_correcta_lista === deletedOption) {
                newQuestions[qIdx].respuesta_correcta_lista = '';
            }
            return { ...prev, questions: newQuestions };
        });
    };

    // Añadir pregunta
    const handleAddQuestion = () => {
        setFormData((prev) => ({
            ...prev,
            questions: [...prev.questions, createEmptyQuestion()],
        }));
    };

    // Eliminar pregunta
    const handleDeleteQuestion = (index) => {
        setFormData((prev) => {
            const newQuestions = [...prev.questions];
            if (newQuestions.length === 1) {
                return { ...prev, questions: [createEmptyQuestion()] };
            } else {
                newQuestions.splice(index, 1);
                return { ...prev, questions: newQuestions };
            }
        });
    };

    const handleCancel = () => {
        setFormData({
            nombre: '',
            tipo: '',
            fabricante: '',
            periodicidad: '',
            questions: [createEmptyQuestion()],
            status: false,
            ejecutor: ''
        });
        onClose();
    };

    const handleSave = async () => {
        try {
            // 1. Crear tipo rutina
            const tipoRutinaRes = await api.post('/tipos_rutinas/', {
                fabricante_id: formData.fabricante,
                nombre: formData.nombre,
                is_active: formData.status,
                periodicidad: formData.periodicidad,
                ejecutor: formData.ejecutor
            });

            const tipoRutinaId = tipoRutinaRes.data.id;

            // 2. Iterar sobre cada pregunta
            for (const pregunta of formData.questions) {
                let semaforoId = null;

                if (pregunta.aplica_semaforo) {
                    if (pregunta.tipo_respuesta_label === 'numero') {
                        const semaforoRes = await api.post('/semaforos/', {
                            rango_max: parseFloat(pregunta.maximo) || 0,
                            rango_min: parseFloat(pregunta.minimo) || 0,
                            is_active: true
                        });
                        semaforoId = semaforoRes.data.id;
                    } else if (pregunta.tipo_respuesta_label === 'lista') {
                        // Lógica para tipo 'lista': usa resp_correct_list y lo asigna a rango_max y rango_min
                        //console.log(pregunta.respuesta_correcta_lista)
                        const semaforoRes = await api.post('/semaforos/', {
                            valor_objetivo: pregunta.respuesta_correcta_lista, // Envía el valor de respuesta_correcta_lista
                            is_active: true
                        });
                        //console.log(semaforoRes)

                        semaforoId = semaforoRes.data.id;
                    }
                }

                //console.log('Crear pregunta ')
                // 2.2 Crear pregunta rutina
                const preguntaRes = await api.post('/preguntas_rutinas/', {
                    tipo_rutina_id: tipoRutinaId,
                    pregunta: pregunta.pregunta,
                    id_tipo_respuesta: pregunta.tipo_respuesta, // ya debe ser el ID
                    orden: parseInt(pregunta.orden) || 0,
                    responsabilidad: "",
                    nombre_elemento: "",
                    observaciones: '',
                    idioma: 'es',
                    semaforo_id: semaforoId
                });

                const preguntaId = preguntaRes.data.id;
                //console.log(preguntaId)

                // 2.3 Si el tipo es "Lista", crear cada opción
                if (pregunta.tipo_respuesta_label === 'lista') {
                    for (const opcion of pregunta.opciones) {
                        await api.post('/listas_respuestas/', {
                            pregunta_id: preguntaId,
                            nombre: opcion,
                            is_active: true
                        });
                    }
                }
            }

            alert('Tipo de rutina y preguntas creadas exitosamente');
            if (onSave) {
                onSave();  // Esto actualizará la lista en el dashboard
            }

            onClose(); // También cierra el diálogo
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Ocurrió un error al guardar el tipo de rutina.');
        }
    };


    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h5">Crear tipo de rutina</Typography>
                    <Typography variant="body2" color="text.secondary">Tipo rutina &gt; Crear tipo rutina</Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={3}>
                    {/* Datos generales */}
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Datos generales del tipo de rutina</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField fullWidth label="Nombre" name="nombre" value={formData.nombre} onChange={handleChange} variant="outlined" size="small" />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Fabricante</InputLabel>
                            <Select
                                label="Fabricante"
                                name="fabricante"
                                value={formData.fabricante}
                                onChange={handleChange}
                            >
                                {fabricantes.map((fab) => (
                                    <MenuItem key={fab.id} value={fab.id}>
                                        {fab.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Periodicidad</InputLabel>
                            <Select label="Periodicidad" name="periodicidad" value={formData.periodicidad} onChange={handleChange}>
                                {lista_periodicidad.map((periodicidad) => (
                                    <MenuItem key={periodicidad} value={periodicidad}>{periodicidad}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel>Ejecutor</InputLabel>
                            <Select label="Ejecutor" name="ejecutor" value={formData.ejecutor} onChange={handleChange}>
                                {roles.map((role) => (
                                    <MenuItem key={role} value={role}>{role}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControlLabel
                            control={<Switch checked={formData.status} onChange={handleChange} name="status" color="primary" />}
                            label="Estatus"
                            labelPlacement="start"
                            sx={{ m: 0, justifyContent: 'space-between', width: '100%' }}
                        />

                    </Grid>

                    {/* Título preguntas */}
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Preguntas correspondientes al tipo rutina</Typography>
                    </Grid>

                    {/* Preguntas dinámicas */}
                    {formData.questions.map((question, index) => (
                        <React.Fragment key={index}>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                <TextField
                                    fullWidth
                                    label="Pregunta"
                                    name="pregunta"
                                    value={question.pregunta}
                                    onChange={e => handleQuestionChange(index, e)}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                            <Grid size={{ xs: 6, sm: 4 }}>
                                <TextField
                                    fullWidth
                                    label="Orden"
                                    name="orden"
                                    value={question.orden}
                                    onChange={e => handleQuestionChange(index, e)}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>

                            <Grid size={{ xs: 6, sm: 4 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={question.aplica_semaforo}
                                            onChange={e => handleQuestionChange(index, e)}
                                            name="aplica_semaforo"
                                        />
                                    }
                                    label="Aplica para semáforo"
                                />
                            </Grid>


                            <Grid size={{ xs: 6, sm: 4 }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <InputLabel>Tipo de respuesta</InputLabel>
                                    <Select
                                        label="Tipo de respuesta"
                                        name="tipo_respuesta"
                                        value={question.tipo_respuesta}
                                        onChange={e => handleQuestionChange(index, e)}
                                    >
                                        <MenuItem value=""><em>Ninguno</em></MenuItem>
                                        {tiposRespuesta
                                            .filter(tipo => {
                                                if (question.aplica_semaforo) {
                                                    return tipo.tipo === 'lista' || tipo.tipo === 'numero';
                                                }
                                                return true;
                                            })
                                            .map((tipo) => (
                                                <MenuItem key={tipo.id} value={tipo.id}>{tipo.tipo}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Opciones de lista y campo "Respuesta Correcta" para tipo 'Lista' */}
                            {question.tipo_respuesta_label === 'lista' && (
                                <>
                                    <Grid size={{ xs: 6, sm: 4 }}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <TextField
                                                label="Agregar opción"
                                                size="small"
                                                value={question.opcion_temp || ''}
                                                onChange={e => handleOpcionTempChange(index, e.target.value)}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        handleAddOpcion(index);
                                                    }
                                                }}
                                            />
                                            <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => handleAddOpcion(index)}
                                                disabled={!question.opcion_temp}
                                            >
                                                Agregar
                                            </Button>
                                        </Box>
                                        {/* Mostrar opciones agregadas */}
                                        <Box mt={1}>
                                            {question.opciones.map((op, idx) => (
                                                <Button
                                                    key={idx}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ mr: 1, mb: 1 }}
                                                    onClick={() => handleDeleteOpcion(index, idx)}
                                                >
                                                    {op} &times;
                                                </Button>
                                            ))}
                                        </Box>
                                    </Grid>

                                    {/* Campo "Respuesta Correcta" si semáforo está activo y es tipo Lista */}
                                    {question.aplica_semaforo && (
                                        <Grid size={{ xs: 6, sm: 4 }}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <InputLabel>Respuesta Correcta</InputLabel>
                                                <Select
                                                    label="Respuesta Correcta"
                                                    name="respuesta_correcta_lista"
                                                    value={question.respuesta_correcta_lista}
                                                    onChange={e => handleQuestionChange(index, e)}
                                                    disabled={question.opciones.length === 0}
                                                >
                                                    <MenuItem value=""><em>Selecciona</em></MenuItem>
                                                    {question.opciones.map((opcion, idx) => (
                                                        <MenuItem key={idx} value={opcion}>{opcion}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}
                                </>
                            )}


                            {/* Campos Max y Min condicionales para Tipo de Respuesta: Número */}
                            {question.aplica_semaforo && question.tipo_respuesta_label === 'numero' && (
                                <>
                                    <Grid size={{ xs: 6, sm: 4 }}>
                                        <TextField
                                            fullWidth
                                            label="Valor máx"
                                            name="maximo"
                                            value={question.maximo}
                                            onChange={e => handleQuestionChange(index, e)}
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 6, sm: 4 }}>
                                        <TextField
                                            fullWidth
                                            label="Valor min"
                                            name="minimo"
                                            value={question.minimo}
                                            onChange={e => handleQuestionChange(index, e)}
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                        />
                                    </Grid>
                                </>
                            )}


                            <Grid size={{ xs: 12, sm: 12 }}>
                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                    <Grid>
                                        <Button
                                            variant="outlined"
                                            startIcon={<DeleteIcon />}
                                            size="small"
                                            onClick={() => handleDeleteQuestion(index)}
                                        >
                                            Eliminar
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            endIcon={<AddIcon />}
                                            size="small"
                                            onClick={handleAddQuestion}
                                        >
                                            Añadir
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Separador visual entre preguntas si hay más de una */}
                            {formData.questions.length > 1 && index < formData.questions.length - 1 && (
                                <Grid item xs={12} sx={{ borderBottom: '1px dashed #ccc', my: 2 }} />
                            )}
                        </React.Fragment>
                    ))}

                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 3, justifyContent: 'flex-end', gap: 1 }}>
                <Button variant="outlined" onClick={handleCancel}>Cancelar</Button>
                <Button variant="contained" onClick={handleSave}>Guardar</Button>
            </DialogActions>
        </Dialog>
    );
}

export default TipoRutinaCreate;
